import { render } from "./Configuracion.vue?vue&type=template&id=9915bf42&scoped=true"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"

import "./Configuracion.vue?vue&type=style&index=0&id=9915bf42&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9915bf42"]])

export default __exports__